/* Change this file to get your personal Porfolio */

import React from "react";

// Website related settings
const settings = {
  isSplash: true, // Change this to true if you want to use the splash screen.
  useCustomCursor: true, // Change this to false if you want the good'ol cursor
  googleTrackingID: "UA-174238252-2",
};

//Home Page
const greeting = {
  title: "Hello 👋.",
  title2: "Milan",
  logo_name: "milan.p()",
  nickname: "milaan / fanta",
  full_name: "Milan Panta",
  subTitle: "Full Stack Developer, Open Source Enthusiast 🔥. Always learning.",
  resumeLink:
    "https://drive.google.com/file/d/1Ewnnqpx5Im_8azbUyL8cwbgYzLaq-lbE/view?usp=sharing",
  mail: "pantamilan2021@gmail.com",
};

const socialMediaLinks = {
  /* Your Social Media Link */
  github: "https://github.com/kingmaker9841",
  gmail: "pantamilan2021@gmail.com",
  gitlab: "https://gitlab.com/kingmaker9841",
  facebook: "https://www.facebook.com/milan.panta.200570",
};

const skills = {
  data: [
    {
      title: "Full Stack Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Develop highly interactive Front end / User Interfaces for your web and mobile applications",
        "⚡ Building responsive website front end using ReactJS",
        "⚡ Developing mobile applications using ReactNative",
        "⚡ Creating application backend in Node & Express",
        "⚡ Integration of third party services such as Firebase/ AWS / Digital Ocean",
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#FFFFFF",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "Typescript",
          fontAwesomeClassname: "simple-icons:typescript",
          style: {
            backgroundColor: "#FFFFFF",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "NextJS",
          fontAwesomeClassname: "simple-icons:next-dot-js",
          style: {
            color: "#000000",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "simple-icons:node-dot-js",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "NPM",
          fontAwesomeClassname: "simple-icons:npm",
          style: {
            color: "#CB3837",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#439743",
          },
        },

        {
          skillName: "MySQL",
          fontAwesomeClassname: "simple-icons:mysql",
          style: {
            color: "#4479A1",
          },
        },
        {
          skillName: "jQuery",
          fontAwesomeClassname: "simple-icons:jquery",
          style: {
            color: "#0865A6",
          },
        },
        {
          skillName: "Wordpress",
          fontAwesomeClassname: "simple-icons:wordpress",
          style: {
            color: "#207297",
          },
        },
        {
          skillName: "Git",
          fontAwesomeClassname: "simple-icons:git",
          style: {
            color: "#E94E32",
          },
        },
        {
          skillName: "C",
          fontAwesomeClassname: "simple-icons:c",
          style: {
            color: "#E94E32",
          },
        },
        {
          skillName: "C++",
          fontAwesomeClassname: "simple-icons:cplusplus",
          style: {
            color: "#E94E32",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "simple-icons:python",
          style: {
            color: "#3776AB",
          },
        },
      ],
    },
    {
      title: "Cloud Infra-Architecture",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Experience working on multiple cloud platforms",
        "⚡ Experience hosting and managing websites",
        "⚡ Experience with Continuous Integration",
      ],
      softwareSkills: [
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: {
            color: "#FF9900",
          },
        },
        {
          skillName: "Netlify",
          fontAwesomeClassname: "simple-icons:netlify",
          style: {
            color: "#38AFBB",
          },
        },
        {
          skillName: "Heroku",
          fontAwesomeClassname: "simple-icons:heroku",
          style: {
            color: "#6863A6",
          },
        },
        {
          skillName: "Firebase",
          fontAwesomeClassname: "simple-icons:firebase",
          style: {
            color: "#FFCA28",
          },
        },
        {
          skillName: "PostgreSQL",
          fontAwesomeClassname: "simple-icons:postgresql",
          style: {
            color: "#336791",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#1488C6",
          },
        },
        {
          skillName: "GitHub Actions",
          fontAwesomeClassname: "simple-icons:githubactions",
          style: {
            color: "#5b77ef",
          },
        },
      ],
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Amrit Science Campus (ASCOL)",
      subtitle:
        "Bachelor in Computer Science and Information Technology (CSIT)",
      logo_path: "ssec.png",
      alt_name: "SSEC",
      duration: "2014-2018",
      descriptions: [
        // "⚡ I'm currently pursuing my bachelors in Information Technology."
        "⚡ I have studied core subjects like Data Structures, DBMS, Networking, Security, etc.",
        "⚡ I have also completed various online courses for Backend , Web , Mobile App Development, etc.",
        "⚡ I have implemented several projects based on what I've leart under my Computer Engineering course. ",
      ],
      website_link: "http://amritcampus.edu.np/",
    },
    {
      title: "Bagmati Modern College",
      subtitle: "Major in Physics and Math",
      logo_path: "ssgandhy.png",
      alt_name: "SSGC",
      duration: "2011-2013",
      descriptions: [
        // "⚡ I have studied core subjects like Data Structures, DBMS, Networking, Security, etc.",
        // "⚡ I have also completed various online courses for Backend , Web , Mobile App Development, etc.",
        // "⚡ I have implemented several projects based on what I've leart under my Computer Engineering course. ",
      ],
      website_link: "https://bagmaticollege.edu.np/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "M0001: MongoDB Basics",
      subtitle: "MongoDB University",
      logo_path: "mongo.png",
      certificate_link:
        "https://drive.google.com/file/d/12se6bMep48WXA1PlizTBAgCnW0GXM6wq/view?usp=sharing",
      alt_name: "MongoDB University",
      // color_code: "#2AAFED",
      color_code: "#47A048",
    },
    {
      title: "Hackathon",
      subtitle: "Hack The Mountains",
      logo_path: "hackathon1.svg",
      certificate_link:
        "https://drive.google.com/file/d/1Y-HT1flWDfeyfnfqVr3ubNgGIcnuUEYt/view?usp=sharing",
      alt_name: "hackathon",
      color_code: "#E2405F",
    },
    {
      title: "A300: Atlas Security",
      subtitle: "MongoDB University",
      logo_path: "mongo.png",
      certificate_link:
        "https://drive.google.com/file/d/12u_tkvhgB-K2TIm-RDdJOwYbQ9ccqiqA/view?usp=sharing",
      alt_name: "MongoDB University",
      // color_code: "#F6B808",
      color_code: "#47A048",
    },
    {
      title: "Cyber Security & Cyber Forensics",
      subtitle: "Workshop at IIT Bombay",
      logo_path: "iit.png",
      certificate_link:
        "https://drive.google.com/file/d/12uAdjQC5LfrB1ODdxqIY181ugyyQhl-I/view?usp=sharing",
      alt_name: "Workshop",
      color_code: "#2AAFED",
    },
    {
      title: "MLH Local Hack Day: Build",
      subtitle: "Major League Hacking",
      logo_path: "mlh-logo.svg",
      certificate_link:
        "https://drive.google.com/file/d/1ws7g2Oepu76vDFir6SvR_emFAMSkB2ZQ/view?usp=sharing",
      alt_name: "Google",
      color_code: "#fe0037",
    },
    {
      title: "Hack20",
      subtitle: "Flutter International Hackathon",
      logo_path: "flutter.png",
      certificate_link:
        "https://drive.google.com/file/d/1JTd8pVlHbP0RVQYtfa4OZgJYGfdiCwM6/view?usp=sharing",
      alt_name: "Flutter International Hackathon",
      color_code: "#2AAFED",
    },
    {
      title: "Postman Student Expert",
      subtitle: "Postman",
      logo_path: "postman.png",
      certificate_link:
        "https://badgr.com/public/assertions/h2qevHs4SlyoHErJQ0mn2g",
      alt_name: "Postman",
      // color_code: "#f36c3d",
      color_code: "#fffbf3",
    },
    // color_code: "#8C151599",
    // color_code: "#7A7A7A",
    // color_code: "#0C9D5899",
    // color_code: "#C5E2EE",
    // color_code: "#ffc475",
    // color_code: "#g",
    // color_code: "#ffbfae",
    // color_code: "#fffbf3",
    // color_code: "#b190b0",
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work, Internship and Volunteership",
  description:
    "I've worked at companies from startup to established ones as a software engineer, specializing in full-stack development and frontend technologies. I love mentoring junior developers and building scalable applications.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work Experience",
      experiences: [
        {
          title: "Senior Software Engineer (Level II)",
          company: "Fusemachines Pvt. Ltd",
          company_url: "https://fusemachines.com/",
          logo_path: "fusemachines.png",
          duration: "Apr 2024 - Apr 2025",
          location: "Remote",
          description: (() => {
            return (
              <div>
                <p>
                  Led development of AI-driven web applications using TypeScript
                  and ReactJS, ensuring high scalability and performance.
                </p>
                <p>
                  Integrated RESTful APIs and WebSocket connections to enable
                  real-time updates and seamless backend communication.
                </p>
                <p>
                  Mentored frontend engineers, promoting best practices in
                  modern JavaScript, code reviews, and scalable architecture.
                </p>
                <p>
                  Aligned UX/UI designs with technical feasibility, improving
                  usability and accessibility.
                </p>
                <p>
                  Championed CI/CD adoption with GitLab, reducing deployment
                  time and increasing release reliability by 30%.
                </p>
              </div>
            );
          })(),
          color: "#0066cc",
        },
        {
          title: "Senior Frontend Engineer",
          company: "BookMundi",
          company_url: "https://bookmundi.com/",
          logo_path: "bookmundi.jpeg",
          duration: "Dec 2023 - Apr 2024",
          location: "Remote",
          description: (() => {
            return (
              <div>
                <p>
                  Migrated an 8+ year legacy codebase (Angular, PHP, React v16,
                  Nuxt) to a Next.js v14 architecture, eliminating technical
                  debt and consolidating multiple systems into a single scalable
                  platform.
                </p>
                <p>
                  Preserved SEO performance during migration by implementing
                  server-side rendering and optimizing page structure.
                </p>
                <p>
                  Developed booking platform features including hotel lodging
                  integration, trip duration management, and travel cost
                  calculators.
                </p>
                <p>
                  Managed a cross-functional team, mentoring junior developers
                  and bridging knowledge gaps in new architecture adoption.
                </p>
                <p>
                  Delivered the modernization project on time within a 4-month
                  contract while ensuring API continuity and platform stability.
                </p>
              </div>
            );
          })(),
          color: "#ff6b35",
        },
        {
          title: "Frontend Engineer",
          company: "Infinity Digital Agency",
          company_url: "https://infinitydigitalagency.com.np/",
          logo_path: "ida.png",
          duration: "Jul 2021 - Oct 2023",
          location: "Remote",
          description: (() => {
            return (
              <div>
                <p>
                  Developed SEO-optimized static marketing pages using Next.js
                  static site generation (SSG), improving organic search
                  rankings.
                </p>
                <p>
                  Improved page speed and Core Web Vitals scores to enhance user
                  experience and SEO performance.
                </p>
                <p>
                  Delivered responsive, brand-consistent designs across multiple
                  device types.
                </p>
                <p>
                  Worked closely with marketing teams to create high-conversion
                  landing pages.
                </p>
              </div>
            );
          })(),
          color: "#8b5cf6",
        },

        {
          title: "Frontend Developer",
          company: "Identv Solutions",
          company_url: "https://www.identv.com/",
          logo_path: "identv.jpeg",
          duration: "Jun 2019 - Jun 2021",
          location: "Work From Home",
          description: (() => {
            return (
              <div>
                <b>Video Tagging (ACR and Juicer)</b>
                <p>
                  Engineered the frontend for the 'Video Juicer' platform using
                  React/TypeScript, creating interactive dashboards to visualize
                  computer vision data.
                </p>
                <p>
                  Developed modular UI components for the 'ACR Platform,'
                  facilitating video fingerprinting workflows and content
                  protection.
                </p>
                <p>
                  Optimized rendering performance for large-scale video
                  datasets, reducing manual content tagging time by 50%.
                </p>
                <p>
                  Built custom analytics plugins that translated intricate video
                  detection data into digestible, actionable insights.
                </p>
                <p>
                  Collaborated with design and backend teams to ensure seamless
                  integration of video playback and real-time metadata.
                </p>
              </div>
            );
          })(),
          color: "#ee3c26",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects make use of a vast variety of latest technology tools. My best experience is to create NodeJS Backend Projects, Python Scripts, and React Project. Below are some of my projects. Note that not all of the mentioned projects are on GitHub yet.",
  avatar_image_path: "projects_image.svg",
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "milan.jpg",
    description:
      "You can contact me at the places mentioned below. I will try to get back to you as fast as I can. ",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "I don't blog frequently but when I do something awesome, I do try to document it so it can be helpful to others. I write on Medium.",
    link: "https://medium.com/@pantamilan2021",
    avatar_image_path: "blogs_image.svg",
  },
};

const openSourceProject = {
  data: [
    {
      id: "0",
      name: "SmartCacheGC",
      url: "https://www.npmjs.com/package/smart-cache-gc",
      description:
        "SmartCache is a memory-efficient in-memory cache built with WeakRef and FinalizationRegistry. It automatically cleans up values when they are garbage collected, helping you avoid memory leaks in high-uptime applications like servers, data processors, or editor tools.",
      languages: [
        {
          name: "HTML5",
          iconifyClass: "vscode-icons:file-type-html",
        },
        {
          name: "Typescript",
          iconifyClass: "logos-typescript",
        },
      ],
    },
  ],
};

const projects = {
  data: [
    {
      id: "0",
      name: "AutomateTiktokBot",
      url: "https://github.com/kingmaker9841/tiktok-live-auto-comment",
      description:
        "This is Tiktok Bot. This will login to your Tiktok account. Goto tiktok users videos, comment on it, comment on live tiktok videos",
      languages: [
        {
          name: "Nodejs",
          iconifyClass: "logos-nodejs",
        },
        {
          name: "Puppeteer",
          iconifyClass: "logos-puppeteer",
        },
        {
          name: "JavaScript",
          iconifyClass: "logos-javascript",
        },
      ],
    },
    {
      id: "1",
      name: "react-twitter-clone",
      url: "https://github.com/kingmaker9841",
      description:
        "A React Twitter Clone UI with basic functionality such as make a Tweet.Embedded Profile Tweets and Share on Twitter.",
      languages: [
        {
          name: "HTML5",
          iconifyClass: "vscode-icons:file-type-html",
        },
        {
          name: "CSS3",
          iconifyClass: "vscode-icons:file-type-css",
        },
        {
          name: "React",
          iconifyClass: "logos-react",
        },
        {
          name: "Firebase",
          iconifyClass: "logos-firebase",
        },
      ],
    },
    {
      id: "2",
      name: "Apollo-upload",
      url: "https://github.com/kingmaker9841/apollo-multiple-upload",
      description:
        "A simple multiple file upload to S3 and local storage with apollo server express (for learning purposes).",
      languages: [
        {
          name: "NodeJS",
          iconifyClass: "logos-nodejs",
        },
        {
          name: "GraphQl",
          iconifyClass: "logos-graphql",
        },
        {
          name: "ApolloGrpahQl",
          iconifyClass: "simple-icons:apollographql",
        },
      ],
    },
    {
      id: "3",
      name: "stack-implementation",
      url: "https://github.com/kingmaker9841/stack-implementation",
      description:
        "Stack Implementation using Javascript in local store (for learning purposes)",
      languages: [
        {
          name: "HTML5",
          iconifyClass: "vscode-icons:file-type-html",
        },
        {
          name: "CSS3",
          iconifyClass: "vscode-icons:file-type-css",
        },
        {
          name: "JavaScript",
          iconifyClass: "logos-javascript",
        },
      ],
    },
    {
      id: "4",
      name: "personal-portfolio",
      url: "https://github.com/kingmaker9841/port",
      description: "A simple portfolio project to know more about me :).",
      languages: [
        {
          name: "JavaScript",
          iconifyClass: "logos-javascript",
        },
        {
          name: "ReactJS",
          iconifyClass: "logos-react",
        },
        {
          name: "Sass",
          iconifyClass: "vscode-icons:file-type-sass",
        },
        {
          name: "HTML5",
          iconifyClass: "vscode-icons:file-type-html",
        },
        {
          name: "CSS3",
          iconifyClass: "vscode-icons:file-type-css",
        },
      ],
    },
    {
      id: "3",
      name: "khalti-wallet",
      url: "https://github.com/kingmaker9841/khalti1",
      description:
        "Simple React application showing usecase of khalti wallet-api.",
      languages: [
        {
          name: "ReactJS",
          iconifyClass: "logos-react",
        },
        {
          name: "HTML5",
          iconifyClass: "vscode-icons:file-type-html",
        },
        {
          name: "CSS3",
          iconifyClass: "vscode-icons:file-type-css",
        },
        {
          name: "JavaScript",
          iconifyClass: "logos-javascript",
        },
      ],
    },
    {
      id: "4",
      name: "node-web-scrapper",
      url: "https://github.com/kingmaker9841",
      description:
        "A Simple web scrapper that scrap the information of amazon products such as price.It also scrap Wikipedia Data such as birthdate.",
      languages: [
        {
          name: "HTML5",
          iconifyClass: "vscode-icons:file-type-html",
        },
        {
          name: "CSS3",
          iconifyClass: "vscode-icons:file-type-css",
        },
        {
          name: "NodeJs",
          iconifyClass: "logos-nodejs",
        },
      ],
    },
    {
      id: "5",
      name: "crypto-wallet",
      url: "https://github.com/kingmaker9841/meta-crypto",
      description: "A Simple crypto wallet connector",
      languages: [
        {
          name: "HTML5",
          iconifyClass: "vscode-icons:file-type-html",
        },
        {
          name: "CSS3",
          iconifyClass: "vscode-icons:file-type-css",
        },
        {
          name: "JavaScript",
          iconifyClass: "logos-javascript",
        },
        {
          name: "Typescript",
          iconifyClass: "logos:typescript-icon",
        },
      ],
    },
    {
      id: "6",
      name: "Automate Attendace",
      url: "https://github.com/kingmaker9841",
      description: "Automation of Online Attendance using node js and python",
      languages: [
        {
          name: "JavaScript",
          iconifyClass: "logos-javascript",
        },
        {
          name: "Python",
          iconifyClass: "logos-python",
        },
      ],
    },
    {
      id: "7",
      name: "Sajabazar",
      url: "https://github.com/kingmaker9841/mern-project-first",
      description: "A MERN project showcasing CRUD operations",
      languages: [
        {
          name: "NodeJS",
          iconifyClass: "logos-nodejs",
        },
        {
          name: "ReactJS",
          iconifyClass: "logos-react",
        },
        {
          name: "HTML5",
          iconifyClass: "vscode-icons:file-type-html",
        },
        {
          name: "CSS3",
          iconifyClass: "vscode-icons:file-type-css",
        },
        {
          name: "JavaScript",
          iconifyClass: "logos-javascript",
        },
        {
          name: "MongoDB",
          iconifyClass: "vscode-icons:file-type-mongo",
        },
      ],
    },
    {
      id: "8",
      name: "Classiestate",
      url: "https://github.com/kingmaker9841/classiEstate",
      description: "A Simple Web Application for real estate",
      languages: [
        {
          name: "ReactJS",
          iconifyClass: "logos-react",
        },
        {
          name: "HTML5",
          iconifyClass: "vscode-icons:file-type-html",
        },
        {
          name: "CSS3",
          iconifyClass: "vscode-icons:file-type-css",
        },
        {
          name: "JavaScript",
          iconifyClass: "logos-javascript",
        },
      ],
    },
    {
      id: "9",
      name: "websocket-test",
      url: "https://github.com/kingmaker9841/websocket-test",
      description: "Simple chat application (For Learning purposes)",
      languages: [
        {
          name: "JavaScript",
          iconifyClass: "logos-javascript",
        },
        {
          name: "HTML5",
          iconifyClass: "logos-html-5",
        },
        {
          name: "CSS3",
          iconifyClass: "logos-css-3",
        },
        {
          name: "SocketIO",
          iconifyClass: "logos:socket-io",
        },
      ],
    },
    {
      id: "10",
      name: "COVID-19 Tracker",
      url:
        "https://github.com/kingmaker9841/nodemailer-test/blob/master/package.json",
      description: "Simple messaging (For learning purposes)",
      languages: [
        {
          name: "JavaScript",
          iconifyClass: "logos-javascript",
        },
        {
          name: "MongoDB",
          iconifyClass: "vscode-icons:file-type-mongo",
        },
        {
          name: "NodeJs",
          iconifyClass: "logos-nodejs",
        },
        {
          name: "ReactJS",
          iconifyClass: "logos-react",
        },
      ],
    },
    {
      id: "11",
      name: "Food Order Static Website",
      url: "https://github.com/kingmaker9841/onlinefooddelivery",
      description:
        "A simple static website related to food restaurants service. this is reasponsive as well.",
      languages: [
        {
          name: "HTML5",
          iconifyClass: "logos-html-5",
        },
        {
          name: "CSS3",
          iconifyClass: "logos-css-3",
        },
        {
          name: "JavaScript",
          iconifyClass: "logos-javascript",
        },
        {
          name: "NodeJS",
          iconifyClass: "logos-nodejs",
        },
        {
          name: "Redux",
          iconifyClass: "logos-redux",
        },
        {
          name: "ReactJS",
          iconifyClass: "logos-react",
        },
      ],
    },
    // {
    //   id: "12",
    //   name: "NFT Launchpad",
    //   url: "https://deliquescent-cents.000webhostapp.com/",
    //   description: "NFT Launchpad crypto site portfolio",
    //   languages: [
    //     {
    //       name: "HTML5",
    //       iconifyClass: "logos-html-5",
    //     },
    //     {
    //       name: "CSS3",
    //       iconifyClass: "logos-css-3",
    //     },
    //     {
    //       name: "JavaScript",
    //       iconifyClass: "logos-javascript",
    //     },
    //     {
    //       name: "ReactJS",
    //       iconifyClass: "logos-react",
    //     },
    //   ],
    // },
  ],
};

export {
  settings,
  greeting,
  socialMediaLinks,
  skills,
  degrees,
  certifications,
  experience,
  projectsHeader,
  contactPageData,
  projects,
  openSourceProject,
};
